var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPinned({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "a/icons/micro/16/map-pinned") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a/icons/micro/16/map-pinned",
    stroke: "none",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    stroke: "color(display-p3 0.000 0.000 0.000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,5.33333333 C12,7.742 9.42066667,10.286 8.40466667,11.1966667 C8.1657491,11.3791539 7.8342509,11.3791539 7.59533333,11.1966667 C6.58,10.286 4,7.742 4,5.33333333 C4,3.12419433 5.790861,1.33333333 8,1.33333333 C10.209139,1.33333333 12,3.12419433 12,5.33333333",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8,
    cy: 5.33333333,
    r: 1.33333333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.80933333,9.33333331 L3.336,9.33333331 C3.04935056,9.33345532 2.79486785,9.51680099 2.704,9.78866667 L1.368,13.7886667 C1.30005378,13.9919535 1.33399425,14.2155112 1.45921403,14.3894716 C1.5844338,14.563432 1.78565868,14.6665755 2,14.6666667 L14,14.6666667 C14.2141781,14.6665041 14.4152362,14.5634495 14.5404233,14.3896666 C14.6656103,14.2158837 14.6996804,13.9925369 14.632,13.7893333 L13.2986667,9.78933333 C13.207952,9.5169715 12.9530716,9.33326421 12.666,9.33333331 L10.1913333,9.33333331",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPinned);
export default __webpack_public_path__ + "static/media/map-pinned.4d7ed49c0b0777599235f2fa574f38e5.svg";
export { ForwardRef as ReactComponent };